import { render, staticRenderFns } from "./DictionaryList.vue?vue&type=template&id=a7a5f0be&scoped=true"
import script from "./DictionaryList.vue?vue&type=script&lang=js"
export * from "./DictionaryList.vue?vue&type=script&lang=js"
import style0 from "./DictionaryList.vue?vue&type=style&index=0&id=a7a5f0be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a5f0be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7a5f0be')) {
      api.createRecord('a7a5f0be', component.options)
    } else {
      api.reload('a7a5f0be', component.options)
    }
    module.hot.accept("./DictionaryList.vue?vue&type=template&id=a7a5f0be&scoped=true", function () {
      api.rerender('a7a5f0be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/SystemBaseEnumData/DictionaryList/DictionaryList.vue"
export default component.exports